import { ids } from "@icarros/theme-react";
import styled from "styled-components";
const { color, size } = ids;
const getImageSize = (internalSize) => {
    switch (internalSize) {
        case "xsmall":
            return `
      height: ${size.general.ids_size_general_96x};
      width: 148px;
    `;
        case "small":
            return `
      height: ${size.general.ids_size_general_116x};
      width: 187px;
    `;
        case "medium":
            return `
      height: 176px;
      width: 268px;
    `;
        case "large":
            return `
      height: 196px;
      width: 312px;
    `;
        case "xlarge":
            return `
      height: 232px;
      width: 390px;
    `;
        case "huge":
            return `
      height: 272px;
      width: 406px;
    `;
    }
};
const getImageBorder = (border) => {
    switch (border) {
        case "all":
            return `
      border-radius: ${size.general.ids_size_general_12x};
    `;
        case "none":
            return `
      border-radius: unset;
    `;
        case "top":
            return `
      border-top-left-radius: ${size.general.ids_size_general_12x};
      border-top-right-radius: ${size.general.ids_size_general_12x};
    `;
        case "left":
            return `
      border-top-left-radius: ${size.general.ids_size_general_12x};
      border-bottom-left-radius: ${size.general.ids_size_general_12x};
    `;
    }
};
const getTagsSpacing = (hasActionIcon, internalSize) => {
    switch (internalSize) {
        case "xsmall":
            return `
      left: ${size.general.ids_size_general_8x};
      top: ${size.general.ids_size_general_8x};
      ${hasActionIcon && `padding-right: ${size.general.ids_size_general_36x};`}
    `;
        case "xlarge" || "huge":
            return `
      left: ${size.general.ids_size_general_16x};
      top: ${size.general.ids_size_general_16x};
      ${hasActionIcon && `padding-right: ${size.general.ids_size_general_44x};`}
    `;
        default:
            return `
      left: ${size.general.ids_size_general_12x};
      top: ${size.general.ids_size_general_12x};
      ${hasActionIcon && `padding-right: ${size.general.ids_size_general_40x};`}
    `;
    }
};
const getActionIconSpacing = (internalSize) => {
    switch (internalSize) {
        case "xsmall":
            return `
      right: ${size.general.ids_size_general_8x};
      top: ${size.general.ids_size_general_8x};
    `;
        case "xlarge" || "huge":
            return `
      right: ${size.general.ids_size_general_16x};
      top: ${size.general.ids_size_general_16x};
    `;
        default:
            return `
      right: ${size.general.ids_size_general_12x};
      top: ${size.general.ids_size_general_12x};
    `;
    }
};
const getIconCarDimension = (internalSize) => {
    switch (internalSize) {
        case "huge":
            return `width: 57%;`;
        case "xlarge":
            return `width: 57%;`;
        case "large":
            return `width: 60%;`;
        case "medium":
            return `width: 60%;`;
        case "small":
            return `width: 65%;`;
        case "xsmall":
            return `width: 65%;`;
    }
};
export const StyledImageContainer = styled.div `
  overflow: hidden;
  display: flex;
  align-items: center;
  position: relative;
  ${({ size }) => getImageSize(size)};
  border-width: ${size.border_width.ids_size_border_small};
  border-color: ${color.border.ids_color_border_soft};
  border-style: solid;
  ${({ borderRadius }) => getImageBorder(borderRadius)}
  ${({ loading }) => loading &&
    `
    border-color: ${color.action.primary.ids_color_action_primary_base};
    background: ${color.backgrounds.ids_color_bg_base};
  `}
  img {
    object-fit: cover;
  }
`;
export const StyledCenteredContainer = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const TagsContainer = styled.div `
  position: absolute;
  ${({ hasActionIcon, size }) => getTagsSpacing(hasActionIcon, size)}
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: ${size.general.ids_size_general_8x};
  pointer-events: none;
`;
export const ActionIconContainer = styled.div `
  position: absolute;
  ${({ size }) => getActionIconSpacing(size)}
`;
export const StyledIconCarImage = styled.img `
  ${({ size }) => getIconCarDimension(size)};
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;
export const StyledImage = styled.img `
  visibility: ${({ isHidden }) => (isHidden ? "hidden" : "visible")};
  min-height: 100%;
  width: 100%;
  pointer-events: none;
`;
//# sourceMappingURL=ImageCar.style.js.map